export interface AuditLog {
  id: string;
  actorId: string | null;
  actorEmail: string;
  actionType: string;
  targetType: string | null;
  targetId: string | null;
  targetName: string | null;
  metadataJson: string | null;
  createdAt: string;
}

export interface AuditLogFilters {
  actionType?: string;
  companyId?: string;
  fromDate?: string;
  toDate?: string;
}

export interface PagedAuditLogs {
  items: AuditLog[];
  totalCount: number;
  page: number;
  pageSize: number;
}

/** Action type vocabulary written by the API (see AdminAuthOutcomes on the backend). */
export const AUDIT_ACTION_TYPES = [
  'Success',
  'Unauthenticated',
  'Forbidden',
  'Expired',
  'LoggedOut',
  'DashboardViewed',
  'CompanyStatusChanged',
  'DiscountCodeCreated',
  'DiscountCodeUpdated',
  'DiscountCodeDeleted',
  'ImpersonationStarted',
  'ImpersonationEnded',
] as const;
